import { render, staticRenderFns } from "./EditUserInternalModal.vue?vue&type=template&id=2d84b316"
import script from "./EditUserInternalModal.vue?vue&type=script&lang=js"
export * from "./EditUserInternalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports